/* eslint-disable */
import listing from "@/apollo/airports/listing.gql";
import inventory_airports from "@/apollo/airports/inventory_airports.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false,
  airports: []
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 03:44PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 03:44PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 03:45PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Jul 2023 | 01:24PM
   * @param {*} state
   * @param {*} value
   */
  setInventoryAirports: (state, value) => (state.airports = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 03:45PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.fetch_airports);
          resolve(data.fetch_airports);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Jul 2023 | 01:24PM
   * @param {*} { commit }
   * @returns {*}
   */
  inventoryAirports({ commit }) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: inventory_airports }).then(({ data }) => {
        commit("setInventoryAirports", data.inventory_airports);
        resolve(data.inventory_airports);
      });
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating,
  airports: (state) => state.airports
};
